import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import secureStorage from "../../../../services/secureStorage";
import { bgColor } from "../../../../utility/constants/colorManager";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import MainComponent from "../../../components/ui_comps/MainComponent";

function ApiDocIndex() {
  const [payoutAvailable, setPayoutAvailable] = useState(false);
  const [payoutData, setPayoutData] = useState([]);
  const [clientWithoutFinoCoupon, setClientWithoutFinoCoupon] = useState([]);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const clientAccount = useSelector((state) => state.listingSlice.vanDetails);
  const role = secureStorage.getItem(SS_ROLE);

  useEffect(() => {
    let payout = clientSecret.filter(
      (obj) =>
        obj?.serviceType === "payout" ||
        obj?.serviceType === "van" ||
        obj?.serviceProviderName?.toUpperCase() === "CASHFREE" ||
        obj?.serviceProviderName?.toUpperCase() === "AXIS" ||
        obj?.serviceProviderName?.toUpperCase() === "IDFC"
    );
    console.log(payout, "Payout");
    if (payout?.length !== 0) {
      setPayoutAvailable(true);
      setPayoutData(payout);
    }
  }, []);

  useEffect(() => {
    let dataWithoutFinoCoupon = clientSecret.filter(
      (obj) =>
        !(
          (obj?.serviceProviderName?.toUpperCase() === "FINO" &&
            obj?.mechanism.toLowerCase() === "coupon") ||
          (obj?.serviceProviderName?.toUpperCase() === "IDFC" &&
            obj?.mechanism.toLowerCase() === "coupon")
        )
    );
    setClientWithoutFinoCoupon(dataWithoutFinoCoupon);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "scroll",
        boxSizing: "border-box",
        backgroundColor: bgColor
      }}
    >
      <div style={{ backgroundColor: "white", width: "100%", height: "100%" }}>
        <MainComponent
          filterRequired={false}
          headerTitle="Api Document"
          onClickFilterCall={(data) => {}}
        />

        {role.toUpperCase() === "CLIENT" && (
          <div style={{ padding: "20px" }}>
            {clientWithoutFinoCoupon.map((secret, i) => {
              return (
                <div key={i}>
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p
                        style={{
                          fontSize: "14px",
                          textTransform: "capitalize"
                        }}
                      >
                        {secret?.serviceType}
                      </p>

                      {secret?.serviceType === "payin" &&
                        (secret?.serviceProviderName?.toUpperCase() ===
                          "KOPAY" ||
                          secret?.serviceProviderName?.toUpperCase() ===
                            "1PAY") && (
                          <p style={{ fontSize: "14px", marginLeft: "5px" }}>
                            {" - " + "Mechanism : " + secret?.mechanism}
                          </p>
                        )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px"
                      }}
                    >
                      <p style={{ width: 140, fontSize: "14px" }}>
                        Client Secret:
                      </p>
                      <p style={{ fontSize: "14px" }}>{secret?.clientId}</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px"
                      }}
                    >
                      <p style={{ width: 140, fontSize: "14px" }}>Program Id</p>
                      <p style={{ fontSize: "14px" }}>{secret?.program}</p>
                    </div>

                    {secret?.serviceType === "payout" &&
                      secret.mechanism === "van" &&
                      (secret?.serviceProviderName?.toUpperCase() === "ZYRO" ||
                        secret?.serviceProviderName?.toUpperCase() === "AXIS" ||
                        secret?.serviceProviderName?.toUpperCase() ===
                          "IDFC") && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "10px"
                            }}
                          >
                            <p style={{ width: 140, fontSize: "14px" }}>
                              Prefund Account
                            </p>
                            <p style={{ fontSize: "14px" }}>
                              {secret?.debitorAcc[0]?.debitorAccNumber}
                            </p>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "10px"
                            }}
                          >
                            <p style={{ width: 140, fontSize: "14px" }}>
                              Prefund Ifsc
                            </p>
                            <p style={{ fontSize: "14px" }}>
                              {secret?.debitorAcc[0]?.debitorAccIfsc}
                            </p>
                          </div>
                        </>
                      )}

                    <div
                      style={{
                        display: "flex",
                        margin: "10px 0px 40px 0px",
                        justifyContent: "left"
                      }}
                    >
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "ESKAY" ? (
                          <div>
                            <a
                              download
                              href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/EK+Payout+service+v1.0.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                fontSize: "14px",
                                marginBottom: "20px"
                              }}
                            >
                              Download Api Doc
                            </a>
                            <a
                              href="https://documenter.getpostman.com/view/13884712/2s93m7Ufhq"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                marginTop: "10px",
                                marginLeft: "10px",
                                fontSize: "14px"
                              }}
                            >
                              Postman Collection
                            </a>
                          </div>
                        ) : null}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType?.toUpperCase() === "VAN" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "EQUITAS" ? (
                          <div>
                            <a
                              download
                              href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/VAN-PayIn-Service+v1.0.5.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                fontSize: "14px",
                                marginBottom: "20px"
                              }}
                            >
                              Download Api Doc
                            </a>
                            <a
                              href="https://documenter.getpostman.com/view/24574228/2s9YRFWAWy"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                marginTop: "10px",
                                marginLeft: "10px",
                                fontSize: "14px"
                              }}
                            >
                              Postman Collection
                            </a>
                          </div>
                        ) : null}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType?.toUpperCase() === "VAN-UPI" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "EQUITAS" ? (
                          <div>
                            <a
                              download
                              href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/EQ+UPI+Payin+service+V_1.0.0.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                fontSize: "14px",
                                marginBottom: "20px"
                              }}
                            >
                              Download Api Doc
                            </a>
                            <a
                              href="https://documenter.getpostman.com/view/24574228/2sA2xjyquo"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                marginTop: "10px",
                                marginLeft: "10px",
                                fontSize: "14px"
                              }}
                            >
                              Postman Collection
                            </a>
                          </div>
                        ) : null}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "ZYRO" ? (
                          secret.mechanism === "cba" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/ZO+Payout+service+V1.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s93m91Lqe"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : secret.mechanism === "van" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/ZO_VA_Payout+service+V1.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s93z6c3Ji"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "EQUITAS" ? (
                          <div>
                            <a
                              download
                              href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/EQ+Payout+service+V_1.0.1+(1).pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                fontSize: "14px",
                                marginBottom: "20px"
                              }}
                            >
                              Download Api Doc
                            </a>
                            <a
                              href="https://documenter.getpostman.com/view/13884712/2s93m4Yi2m"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                padding: "10px 20px",
                                backgroundColor: "#383693",
                                color: "white",
                                borderRadius: "8px",
                                marginTop: "10px",
                                marginLeft: "10px",
                                fontSize: "14px"
                              }}
                            >
                              Postman Collection
                            </a>
                          </div>
                        ) : null}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payin" &&
                          secret?.serviceProviderName?.toUpperCase() ===
                            "1PAY" &&
                          (secret?.mechanism === "qr" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/1pay_UPI+INTENT+CollectBot+UPI+service.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Document for upi intent
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s946h8CAf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/1Pay+CollectBot+UPI+service.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s946h8CAe"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ))}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payin" &&
                          secret?.serviceProviderName?.toUpperCase() ===
                            "FINO" &&
                          (secret?.mechanism === "qr" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+FN+UPI+Intent+API+service+V_1.0.1.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Document for upi intent
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s946idrho"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+FN+Collect+API+service+V_1.0.1.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s946idrhn"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ))}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                          secret?.serviceProviderName?.toUpperCase() ===
                            "CASHFREE" && (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/Payout+service.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2sA3s1nrqd"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          )}
                      </div>

                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payin" &&
                          secret?.serviceProviderName?.toUpperCase() ===
                            "KOPAY" &&
                          (secret?.mechanism === "qr" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+UPI+Intent+service.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Document for upi intent
                              </a>
                            </div>
                          ) : (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+UPI+service.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/13884712/2s8YzUxgjB"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ))}
                      </div>
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payin" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "NPST" ? (
                          secret.mechanism === "qr" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+NP+INTENT+API+service+V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YyweeK5"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : secret.mechanism === "vba" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/CollectBot+NP+Collect+API+service+V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YyweeK6"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                      {/* AXIS PAYOUT */}
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "AXIS" ? (
                          secret.mechanism === "cba" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/Axis+CBA+Payout+Document.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YJexLYw"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : secret.mechanism === "van" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/Axis+VBA+Payout+Document.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YJexLhp"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                      {/* AXIS VAN */}
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "van" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "AXIS" ? (
                          secret.mechanism === "van" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/AX+VAN+Payin+service+V_1.0.3.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YRDzqA6"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                      {/* IDFC VAN*/}
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "van" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "IDFC" ? (
                          secret.mechanism === "van" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/ID+VAN+Payin+service_V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YeABaGh"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>

                      {/* COUPON */}
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType?.toUpperCase() === "VOUCHER" &&
                          secret?.serviceProviderName?.toUpperCase() ===
                            "NEOKRED" && (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/Voucher+API+service+V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YeHbWgP"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          )}
                      </div>
                      {/* IDFC PAYOUT */}
                      <div style={{ marginTop: "30px" }}>
                        {secret?.serviceType === "payout" &&
                        secret?.serviceProviderName?.toUpperCase() ===
                          "IDFC" ? (
                          secret.mechanism === "cba" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/ID+Payout+service_V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YeHbWc8"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : secret.mechanism === "van" ? (
                            <div>
                              <a
                                download
                                href="https://s3.ap-south-1.amazonaws.com/nkcollect2.0.2/ID+VAN+Payout+service_V_1.0.0.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                  marginBottom: "20px"
                                }}
                              >
                                Download Api Doc
                              </a>
                              <a
                                href="https://documenter.getpostman.com/view/24574228/2s9YeHbWc5"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  padding: "10px 20px",
                                  backgroundColor: "#383693",
                                  color: "white",
                                  borderRadius: "8px",
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                  fontSize: "14px"
                                }}
                              >
                                Postman Collection
                              </a>
                            </div>
                          ) : null
                        ) : null}
                      </div>
                    </div>
                  </>
                </div>
              );
            })}

            {/* {payoutAvailable &&
              payoutData.map((data, i) => {
                return (
                  <>
                    {data.serviceProviderName?.toUpperCase() === "CASHFREE" ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <p
                            style={{
                              fontSize: "14px",
                              textTransform: "capitalize",
                              width: "150px"
                            }}
                          >
                            Debitor account
                          </p>

                          <p style={{ fontSize: "14px", marginLeft: "5px" }}>
                            {clientAccount?.vanAccountId}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px"
                          }}
                        >
                          <p
                            style={{
                              fontSize: "14px",
                              textTransform: "capitalize",
                              width: "150px"
                            }}
                          >
                            Prefund Account IFSC
                          </p>
                          <p style={{ fontSize: "14px", marginLeft: "5px" }}>
                            YESB0CMSNOC
                          </p>
                        </div>
                      </>
                    ) : data?.serviceProviderName?.toUpperCase() ===
                      "EQUITAS" ? null : null}
                  </>
                );
              })} */}
            {payoutAvailable &&
              payoutData.map((data, i) => {
                return (
                  <>
                    {data.serviceProviderName?.toUpperCase() === "CASHFREE" ? (
                      <>
                        {data.debitorAcc?.map((acc, index) => (
                          <React.Fragment key={index}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: index > 0 ? "10px" : "0"
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "14px",
                                  textTransform: "capitalize",
                                  width: "150px"
                                }}
                              >
                                Prefund Acc Number {index + 1}
                              </p>
                              <p
                                style={{ fontSize: "14px", marginLeft: "5px" }}
                              >
                                {acc.debitorAccNumber}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "10px"
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "14px",
                                  textTransform: "capitalize",
                                  width: "150px"
                                }}
                              >
                                Prefund Acc IFSC {index + 1}
                              </p>
                              <p
                                style={{ fontSize: "14px", marginLeft: "5px" }}
                              >
                                {acc.debitorAccIfsc}
                              </p>
                            </div>
                          </React.Fragment>
                        ))}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px"
                          }}
                        ></div>
                      </>
                    ) : data?.serviceProviderName?.toUpperCase() ===
                      "EQUITAS" ? null : null}
                  </>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ApiDocIndex;
